<template>

    <v-page-body>

        <transition name="modal">
            <v-modal-sender-create v-if="showModal === 'create'" @created="getProject" />
            <v-modal-sender-delete v-if="showModal === 'delete'" :sender="selectedSender" @deleted="getProject" />
            <v-modal-sender-edit v-if="showModal === selectedSender.id" :sender="selectedSender" @saved="getProject" />
        </transition>

        <v-page-filters floating>
            <v-searchbar :model="params.q" @input="params.q = $event" :action="getSenders" />
            <v-button size="sm" @click.native="createSender">Add Sender</v-button>
        </v-page-filters>

        <v-notice v-if="!senders.length" title="Add a Sender" message="You can create multiple senders and select one for each email in your automations and broadcasts.">
            <template #footer>
                <v-button @click.native="createSender">Add Sender</v-button>
            </template>
        </v-notice>

        <v-list v-else>
            <v-list-item v-for="sender in senders" :key="sender.id">
                <div>
                    <span>{{ sender.name }}</span><br>
                    <span v-if="sender.is_default" class="small text-primary">Default</span>
                    <span v-if="sender.is_default" class="small text-muted">&nbsp;&bull;&nbsp;</span>
                    <span class="small text-muted">{{ sender.email }} ({{ sender.type}})</span>
                </div>
                <div>
                    <v-button class="float-right" size="sm" btn-style="secondary" @click.native="editSender(sender)">Edit</v-button>
                </div>
            </v-list-item>
        </v-list>

    </v-page-body>

</template>

<script>

import ProjectApi from '@api/ProjectApi';
import ModalSenderCreate from '@modals/sender/ModalSenderCreate';
import ModalSenderDelete from '@modals/sender/ModalSenderDelete';
import ModalSenderEdit from '@modals/sender/ModalSenderEdit';

export default {

    components: {
        'v-modal-sender-create': ModalSenderCreate,
        'v-modal-sender-delete': ModalSenderDelete,
        'v-modal-sender-edit': ModalSenderEdit,
    },

    data() {
        return {
            senders: [],
            selectedSender: {},
            params: {},
        }
    },

    mounted() {
        this.getProject();
    },

    methods: {

        getProject() {
            this.$store.commit('loading', true);
            ProjectApi.getProject(this.project.id)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.senders = response.data.data.senders;
                    this.$events.$emit('pageLoaded');
                }, () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        getSenders() {
            this.$store.commit('loading', true);
            ProjectApi.getSenders(this.project.id, this.params)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.senders = response.data.data;
                }, () => {
                    this.$store.commit('loading', false);
                });
        },

        createSender() {
            this.$store.commit('showModal', 'create');
        },

        editSender(sender) {
            this.selectedSender = sender;
            this.$store.commit('showModal', sender.id);
        },

    },

}

</script>